// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExpandOutlinedSvg from "@fishx/icons-svg/es/asn/ExpandOutlined";
import FishxIcon from '../components/FishxIcon';

var ExpandOutlined = function ExpandOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExpandOutlinedSvg
  }));
};

ExpandOutlined.displayName = 'ExpandOutlined';
export default React.forwardRef(ExpandOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExpandOutlined.js
// module id = 2642
// module chunks = 0